export default {
  role: {
    itself: 'Rol',
    '*': 'Rol *',
    selectRole: 'Selectează rolul',
  },
};
